<template>
    <div class="row">
        <div class="col-12">
            <div class="mb-5" v-html="event.synopsis"></div>
        </div>
        <div class="col-12" v-if="event.underage_policy">
            <div class="mb-5" v-html="event.underage_policy"></div>
        </div>
        <div class="col-12" v-if="event.underage_policy">
            <div class="mb-5"> {{ $t('general.hoja_responsabilidad') }}
                <strong>
                    <a
                        href="https://storage.compralaentrada.com/autorizaciones/compralaentrada-autorizacion-menores.pdf"
                        target="_blank"
                    >
                        <p style="color: black;">{{ $t('general.aqui') }}.</p>
                    </a>
                </strong>
            </div>
        </div>
        <div class="col-12" v-if="event.youtube_id">
            <youtube 
                :video-id="event.youtube_id"
                player-width="100%"
                player-height="100%"
                class="video-responsive"
            />            
        </div>
        <div class="col-12">
            <div class="h5 text-uppercase mb-3">{{ $t('general.compartelo') }}</div>
            <SocialShare :url="event.url_share" scale="2" :subject="event.author" :body="event.name" :title="event.name" class="d-flex justify-content-center"/>
        </div>
    </div>
</template>

<script>
    import SocialShare from '@/components/socialmedia/SocialmediaComponent';

    export default{
        props: {
            event: {
                required: true,
                type: Object
            }
        },
        components: {
            SocialShare
        }
    }
</script>

<style scoped>
    .video-responsive{
        height: 460px;
    }

    @media (max-width: 700px) {
        .video-responsive{
            height: 200px;
        }
    }
</style>